import { alpha, AppBar, styled } from '@mui/material';
import { StackComponent } from 'src/components/common/StackComponent';
import SitesMenu from '../sites/SitesMenu';
import './Header.scss';

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    // width: `calc(100% - ${DRAWER_WIDTH + 1}px)`
  },
  top: '8px'
}));

interface DashboardNavbarProps {
  onOpenSidebar?: () => void;
}

const Navbar: React.FC<DashboardNavbarProps> = () => {
  return (
    <RootStyle className="dashboard-navbar">
      {/* <GridComponent container spacing={1}>
        <GridComponent item xs={6}>
          <ButtonGroupComponent variant="outlined" aria-label="outlined button group" className="top-toolbar">
            {NavBarData.map(d=><ButtonComponent className={d.className} key={d.key}><d.component></d.component></ButtonComponent>)}
          </ButtonGroupComponent>
        </GridComponent>
        <Profile></Profile>
      </GridComponent> */}
      <StackComponent direction="row" alignItems="left" spacing={{ xs: 0.5, sm: 1.5 }}>
        <SitesMenu />
      </StackComponent>
    </RootStyle>
  );
};

export default Navbar;
